import { Children } from 'react';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
function Column({
  align,
  children,
  justify
}) {
  return /*#__PURE__*/_jsx(TFlex, {
    direction: "column",
    align: align,
    justify: justify,
    children: Children.map(children, child => /*#__PURE__*/_jsx("div", {
      children: child
    }))
  });
}

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
Column.defaultProps = {
  align: 'start',
  justify: 'start'
};
export default Column;